<template>
  <div class="pa-3">
    <v-form ref="form">
      <!-- Administration Track Form Step -->
      <v-card class="mb-5">
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Administration Track</v-toolbar-title>
        </v-toolbar>
        <v-col class="pa-10">
          <v-row>
            <v-text-field
              :id="'editrack-' + lang + '-title-input'"
              class="mb-5"
              outlined
              dense
              label="Track Title"
              v-model="content.title"
              required
              :rules="[(v) => !!v || 'Title is required']"
            ></v-text-field>
          </v-row>
        </v-col>
      </v-card>

      <!-- Content Track Form Step -->
      <v-card class="mb-5">
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Content Track</v-toolbar-title>
        </v-toolbar>
        <v-tabs vertical left>
          <!--Submission-->
          <v-tab>
            <v-icon :id="'editrack-content-' + lang + '-submission-tab'" left>{{
              icon.mdiSend
            }}</v-icon>
            Submission
          </v-tab>
          <!--Call For Papers-->
          <v-tab :id="'editrack-content-' + lang + '-callpapers-tab'">
            <v-icon left> {{ icon.mdiAccountVoice }} </v-icon>
            Call for Papers
          </v-tab>
          <!-- Review -->
          <v-tab :id="'editrack-content-' + lang + '-review-tab'">
            <v-icon left> {{ icon.mdiNoteSearchOutline }} </v-icon>
            Review
          </v-tab>
          <!-- Presentation -->
          <v-tab :id="'editrack-content-' + lang + '-presentation-tab'">
            <v-icon left> {{ icon.mdiPresentation }} </v-icon>
            Presentation
          </v-tab>
          <!-- Publication -->
          <v-tab :id="'editrack-content-' + lang + '-publication-tab'">
            <v-icon left>{{ icon.mdiBook }} </v-icon>
            Publication
          </v-tab>
          <!-- Full Papers -->
          <v-tab :id="'editrack-content-' + lang + '-fullpapers-tab'">
            <v-icon left> {{ icon.mdiNoteMultipleOutline }} </v-icon>
            Full Papers
          </v-tab>
          <!-- Short Papers -->
          <v-tab :id="'editrack-content-' + lang + '-shortpapers-tab'">
            <v-icon left> {{ icon.mdiNoteOutline }} </v-icon>
            Short Papers
          </v-tab>
          <!-- Topics -->
          <v-tab :id="'editrack-content-' + lang + '-topics-tab'">
            <v-icon left> {{ icon.mdiFormatListBulleted }} </v-icon>
            Topics
          </v-tab>

          <!--Submission-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-submission-title-input'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Submission Title"
                  v-model="content.submissionTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-submission-content-input'"
                  title="Submission Content"
                  @updateHtml="updateSubmission"
                  class="mb-10"
                  @mounted="
                    setDescriptionText('submission', 'submissionContent')
                  "
                  ref="submission"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Call for Papers-->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-callpapers-title-input'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Call For Papers Title"
                  v-model="content.callForPapersTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-callpapers-content-input'"
                  title="Call For Papers Content"
                  @mounted="
                    setDescriptionText('callforpapers', 'callForPapersContent')
                  "
                  @updateHtml="updateCallForPaper"
                  class="mb-10"
                  ref="callforpapers"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Review -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-review-title-input'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Review Title"
                  v-model="content.reviewTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-review-content-input'"
                  title="Review Content"
                  @updateHtml="updateReview"
                  class="mb-10"
                  @mounted="setDescriptionText('review', 'reviewContent')"
                  ref="review"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Presentation -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-presentation-title-input'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Presentation Title"
                  v-model="content.presentationTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-presentation-content-input'"
                  title="Presentation Content"
                  @updateHtml="updatePresentation"
                  class="mb-10"
                  @mounted="
                    setDescriptionText('presentation', 'presentationContent')
                  "
                  ref="presentation"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Publication -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-publication-title-input'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Publication Title"
                  v-model="content.publicationTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-publication-content-input'"
                  title="Publication Content"
                  @updateHtml="updatePublication"
                  class="mb-10"
                  @mounted="
                    setDescriptionText('publication', 'publicationContent')
                  "
                  ref="publication"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Full Papers -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-fullpapers-title-input'"
                  class="mt-10 mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Full Papers Title"
                  v-model="content.fullPapersTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-fullpapers-content-input'"
                  title="Full Papers Content"
                  @updateHtml="updateFullPapers"
                  class="mb-10"
                  @mounted="
                    setDescriptionText('fullpapers', 'fullPapersContent')
                  "
                  ref="fullpapers"
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Short Papers -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-shortpapers-title-input'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Short Papers Title"
                  v-model="content.shortPapersTitle"
                ></v-text-field>
                <TextBox
                  :id="'editrack-content-' + lang + '-shortpapers-content-input'"
                  title="Short Papers Content"
                  @updateHtml="updateShortPapers"
                  class="mb-10"
                  ref="shortpapers"
                  @mounted="
                    setDescriptionText('shortpapers', 'shortPapersContent')
                  "
                />
              </v-card-text>
            </v-card>
          </v-tab-item>
          <!-- Topics -->
          <v-tab-item>
            <v-card flat>
              <v-card-text>
                <v-text-field
                  :id="'editrack-content-' + lang + '-topics-title'"
                  class="mb-2"
                  :hide-details="true"
                  outlined
                  dense
                  label="Topics Title"
                  v-model="content.topicsTitle"
                ></v-text-field>
                <v-text-field
                  :id="'editrack-content-' + lang + '-topics-input'"
                  outlined
                  dense
                  label="Topics"
                  hint="Write a topic, press ENTER to add"
                  @keypress.enter="addTopic"
                  v-model="currentTopic"
                ></v-text-field>
                <ul>
                  <li v-for="(topic, i) in content.topicsContent" :key="i">
                    {{ topic }}
                    <v-btn
                      :id="'editrack-content-topics-remove-button-' + i"
                      class="ml-1"
                      @click="removeTopic(i)"
                      x-small
                      icon
                      ><v-icon small>{{ icon.mdiClose }}</v-icon></v-btn
                    >
                  </li>
                </ul>
              </v-card-text>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>

      <!-- Deadlines Track Form Step -->
      <v-card class="mb-5">
        <v-toolbar flat color="primary" dark>
          <v-toolbar-title>Deadlines Track</v-toolbar-title>
        </v-toolbar>
        <v-col class="pa-10">
          <v-row>
            <v-container>
              <v-row class="px-0">
                <v-col>
                  <div v-for="(dl, i) in content.deadlines" :key="i * -1 - 1">
                    <v-row class="mb-2 px-3">
                      <div>Deadline {{ i + 1 }}</div>
                      <v-spacer></v-spacer>
                      <v-btn
                        :id="'editrack-' + lang + '-deadline-remove-button-' + i"
                        color="red"
                        :disabled="content.deadlines.length == 1"
                        icon
                        @click="removeDeadline(i)"
                      >
                        <v-icon>{{ icon.mdiClose }}</v-icon>
                      </v-btn>
                    </v-row>

                    <v-row>
                      <v-col cols="12" md="4" class="py-0">
                        <v-text-field
                          :id="'editrack-' + lang + '-deadline-title-input-' + i"
                          label="Deadline Title"
                          :rules="[(v) => !!v || 'Title is required']"
                          required
                          outlined
                          v-model="content.deadlines[i].title"
                        ></v-text-field>
                      </v-col>

                      <v-col cols="12" md="2" class="py-0">
                        <v-menu
                          v-model="menuDate['md' + i]"
                          :close-on-content-click="false"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :id="'editrack-' + lang + '-deadline-date-picker-' + i"
                              v-model="content.deadlines[i].schedule.day"
                              label="Date"
                              :prepend-inner-icon="icon.mdiCalendar"
                              readonly
                              required
                              :rules="[(v) => !!v || 'Date is required']"
                              outlined
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-if="menuDate['md' + i]"
                            v-model="content.deadlines[i].schedule.day"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="menuDate['md' + i] = false"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" md="2" class="py-0">
                        <v-menu
                          ref="menuTime"
                          v-model="menuTime['mt' + i]"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          :return-value.sync="time"
                          transition="scale-transition"
                          offset-y
                          max-width="290px"
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              :id="'editrack-' + lang + '-deadline-time-picker-' + i"
                              v-model="content.deadlines[i].schedule.time"
                              label="Time"
                              :prepend-inner-icon="icon.mdiClockTimeFourOutline"
                              readonly
                              outlined
                              required
                              :rules="[(v) => !!v || 'Time is required']"
                              v-bind="attrs"
                              v-on="on"
                            ></v-text-field>
                          </template>
                          <v-time-picker
                            v-if="menuTime['mt' + i]"
                            v-model="content.deadlines[i].schedule.time"
                            full-width
                            @click:minute="menuTime['mt' + i] = false"
                          ></v-time-picker>
                        </v-menu>
                      </v-col>

                      <v-col cols="12" md="2" class="py-0">
                        <v-select
                          :id="'editrack-' + lang + '-deadline-type-select-' + i"
                          outlined
                          label="Type"
                          :items="deadlineTypes"
                          v-model="content.deadlines[i].type"
                        >
                        </v-select>
                      </v-col>
                      <v-col cols="12" md="2" class="py-0">
                        <v-switch
                          :id="'editrack-' + lang + '-deadline-deprecated-switch-' + i"
                          label="Deprecated"
                          v-model="content.deadlines[i].isDeprecated"
                        />
                      </v-col>
                    </v-row>
                  </div>
                  <v-row justify="center" justify-sm="end" class="mx-3">
                    <v-btn
                      :id="'editrack-deadline-new-button'"
                      color="blue"
                      dark
                      @click="addDeadline"
                    >
                      New deadline <v-icon right>{{ icon.mdiPlus }}</v-icon>
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
            </v-container>
          </v-row>
        </v-col>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import TextBox from "@/components/atoms/TextBox.vue";
import { Deadline } from "@/helpers/tracks.js";
import {
  mdiSend,
  mdiAccountVoice,
  mdiNoteSearchOutline,
  mdiPresentation,
  mdiBook,
  mdiNoteMultipleOutline,
  mdiNoteOutline,
  mdiFormatListBulleted,
  mdiClose,
  mdiCalendar,
  mdiClockTimeFourOutline,
  mdiPlus,
} from "@mdi/js";

export default {
  props: ["content", "valid", "lang"],
  components: {
    TextBox,
  },
  data: () => ({
    icon: {
      mdiSend,
      mdiAccountVoice,
      mdiNoteSearchOutline,
      mdiPresentation,
      mdiBook,
      mdiNoteMultipleOutline,
      mdiNoteOutline,
      mdiFormatListBulleted,
      mdiClose,
      mdiCalendar,
      mdiClockTimeFourOutline,
      mdiPlus,
    },
    currentTopic: "",
    color: "#FF00FF",
    deadlineModel: Object.assign({}, new Deadline()),
    menuDate: {},
    menuTime: {},
    date: new Date().toISOString().substr(0, 10),
    time: new Date().getHours + ":" + new Date().getMinutes,
    admin: null,
  }),
  methods: {
    validate() {
      return this.$refs.form.validate();
    },
    required(value) {
      if (value instanceof Object && value.length == 0) {
        return "Required.";
      }
      return !!value || "Required.";
    },
    setDescriptionText(ref, key) {
      this.$refs[ref].setContent(this.content[key]);
    },
    addTopic() {
      this.content.topicsContent.push(this.currentTopic);
      this.currentTopic = "";
    },
    updateCallForPaper(html) {
      this.content.callForPapersContent = html;
    },
    updateFullPapers(html) {
      this.content.fullPapersContent = html;
    },
    updateShortPapers(html) {
      this.content.shortPapersContent = html;
    },
    updateSubmission(html) {
      this.content.submissionContent = html;
    },
    updateReview(html) {
      this.content.reviewContent = html;
    },
    updatePresentation(html) {
      this.content.presentationContent = html;
    },
    updatePublication(html) {
      this.content.publicationContent = html;
    },
    addDeadline() {
      this.content.deadlines.push(new Deadline());
    },
    removeDeadline(index) {
      this.content.deadlines.splice(index, 1);
    },
    removeTopic(index) {
      this.content.topicsContent.splice(index, 1);
    },
  },
  computed: {
    deadlineTypes() {
      //TODO: update to get based on language
      return ["Initial", "Review", "Final"];
    },
  },
  created() {
    if (!this.$store.getters.getUsers) {
      this.$store.dispatch("getAllUsers");
    }
  },
};
</script>

<style scoped>
.subject-title {
  font-size: 100%;
  font-weight: 0;
  color: #4f4f4f;
  font-family: "Open Sans", sans-serif;
}

.primary-title {
  font-size: 130%;
  font-weight: 700;
  color: #4f4f4f;
  font-family: "Open Sans", sans-serif;
}

.dl-list-title {
  color: #777777;
  font-weight: bold;
  font-size: 1.1rem;
  margin-left: 15px;
  margin-top: 10px;
}

.v-tab {
  justify-content: left;
}
</style>
